<template>
  <a-modal destroyOnClose style="height: 80%;overflow-y: auto;" width="80%" v-model="visible" @cancel="close" @ok="handleOk" cancelText="关闭" okText="提交" :closable="false" :destroyOnClose="true" :maskClosable="false">
    <a-row slot="title" style="margin-bottom: 10px">
      <a-row>
        选择题
      </a-row>
    </a-row>
    <a-spin :spinning="loading">
      <a-row>
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="是否必做">
            <a-radio-group :options="requiredOptions" v-model="drill.required"/>
          </a-form-model-item>
          <a-form-model-item label="题干">
            <a-textarea style="width: 80%" v-model="drill.text" placeholder="请输入题干"/>
          </a-form-model-item>
          <a-form-model-item label="题图">
            <CommonUpload :defaultUrl="this.drill.imageUri ? `${$ossHost}${this.drill.imageUri}`: undefined" @changeImgUri="changeImgUri" path="img/drill/"/>
          </a-form-model-item>
          <a-form-model-item v-for="(option, index) in drill.optionList" :label="letter[index]" :key="option.id">
            <a-input style="width: 60%" v-model="option.text" placeholder="请输入选项文字"/>
            <a-checkbox style="margin-left: 10px;" v-model="option.correctAnswer" @change="(e) => changeCorrectAnswer(e, index)">
              <a-tag v-if="option.correctAnswer" color="green">
                正确
              </a-tag>
              <a-tag v-else color="red">
                错误
              </a-tag>
            </a-checkbox>
            <a-icon
              v-if="drill.optionList.length > 1"
              class="dynamic-delete-button"
              type="minus-circle-o"
              @click="removeOption(index)"/>
            <CommonUpload :defaultUrl="option.imageUri ? `${$ossHost}${option.imageUri}`: undefined" @changeImgUri="(uri) => changeOptionImgUri(index, uri)" path="img/drill/"/>
          </a-form-model-item>
          <a-form-model-item v-bind="formItemLayoutWithOutLabel">
            <a-button type="dashed" style="width: 80%" @click="addOption">
              <a-icon type="plus" />增加选项
            </a-button>
          </a-form-model-item>
          <a-form-model-item label="解析">
            <a-textarea style="width: 80%" v-model="drill.explanation" placeholder="请输入解析"/>
          </a-form-model-item>
        </a-form-model>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
import {mapActions} from "vuex";
const OSS = require('ali-oss')
const letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
import ChoiceQuestionDrillApi from '../../../../api/src/drill/api/ChoiceQuestionDrillApi.js'
const choiceQuestionDrillApi = new ChoiceQuestionDrillApi()
import CommonUpload from '../../../../components/CommonUpload.vue'
export default {
  name: "ChoiceQuestionEdit",
  props: {
    visibleTimes: Number,
    info: Object,
    treeData: Array,
    subType: Number,
    selectedKeys: Array,
    currentDrillId: String,
    sectionId: String,
  },
  components: {CommonUpload},
  watch: {
    'visibleTimes': async function(a, b) {
      this.visible = true
      if(this.currentDrillId){
        console.debug(this.currentDrillId)
        this.loading = true
        let resp = await choiceQuestionDrillApi.getDetail(this.currentDrillId)
        console.log(resp)
        this.drill = resp
        this.loading = false
        return
      }
      if(this.subType == 103){
        this.drill.optionList = [{
            text: '正确',
            correctAnswer: false
          },{
            text: '错误',
            correctAnswer: false
          }]
      }
    },
  },
  data() {
    return {
      letter: letter,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
      requiredOptions: [{
        value: false,
        label: '否'
      },{
        value: true,
        label: '是'
      }],
      drill: {
        required: false,
        text: undefined,
        imageUri: undefined,
        optionList: [{
            text: undefined,
            correctAnswer: false
          },{
            text: undefined,
            correctAnswer: false
          },{
            text: undefined,
            correctAnswer: false
          },{
            text: undefined,
            correctAnswer: false
        }],
        explanation: undefined
      },
      fragmentList: [],
      uploading: false,
      loading: false,
      visible: false
    }
  },
  methods:{
    changeImgUri(uri) {
      this.drill.imageUri = uri
      console.log(uri)
    },
    changeOptionImgUri(index, uri) {
      console.log(index, uri)
      this.drill.optionList[index].imageUri = uri
    },
    removeOption(index) {
      this.drill.optionList.splice(index, 1)
    },
    addOption() {
      this.drill.optionList.push({
        text: undefined,
        correctAnswer: false
      })
    },
    beforeUpload(file) {
      let fragment = {
        title: undefined,
        type: 1,
        summary: undefined,
        isVideo: false,
        knowledgeId: this.info.knowledgeId,
        progress: 0,
        file: file
      }
      if(/video/ig.test(fragment.file.type)){
        fragment.isVideo = true
      }
      this.fragmentList.push(fragment)
      return false
    },
    handleChangeFile(e) {
    },
    handlePreview() {

    },
    getDetail() {

    },
    close() {
      if(this.loading){
        this.$message.warning('试题正在上传中，请稍后')
        return
      }
      this.$emit('success', {addDrill: true})
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        imageUri: undefined,
        optionList: [{
            text: undefined,
            correctAnswer: false
          },{
            text: undefined,
            correctAnswer: false
          },{
            text: undefined,
            correctAnswer: false
          },{
            text: undefined,
            correctAnswer: false
        }],
        explanation: undefined
      }
    },
    deleteFile(fragment, index) {
    },
    async handleOk() {
      if(!this.drill.text){
        this.$message.error('请填写题干')
        return
      }
      for(let i = 0; i < this.drill.optionList.length; i++){
        this.drill.optionList[i].id = letter[i]
      }
      if(!this.drill.id){
        this.drill.subType = this.subType
      }
      let correctNum = 0
      let correctAnswer = []
      this.drill.optionList.forEach(option => {
        if(option.correctAnswer){
          correctNum++
          correctAnswer.push(option.id)
        }
      })
      this.drill.correctAnswer = correctAnswer
      if(correctNum < 1){
        this.$message.error('请标记正确选项')
        return
      }
      console.debug(this.drill)
      console.debug(this.$route.params.courseStandardId)
      console.debug(this.selectedKeys[0])
      this.loading = true
      if(!this.drill.id){
        await choiceQuestionDrillApi.create(this.drill, {
          courseStandardId: this.$route.params.courseStandardId,
          knowledgeId: this.selectedKeys[0],
          sectionId: this.sectionId,
          sortKey: 0
        })
      }else{
        await choiceQuestionDrillApi.update(this.drill.id, this.drill)
      }
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        imageUri: undefined,
        optionList: [{
            text: undefined,
            correctAnswer: false
          },{
            text: undefined,
            correctAnswer: false
          },{
            text: undefined,
            correctAnswer: false
          },{
            text: undefined,
            correctAnswer: false
        }],
        explanation: undefined
      }
      this.loading = false
      this.$emit('success', {addDrill: true})
    },
    check() {
      console.log(this.fragmentList)
      let checkFlag = true
      for(let i = 0; i < this.fragmentList.length; i++) {
        if(!this.fragmentList[i].title){
          this.$message.error(`${this.fragmentList[i].file.name}无碎片名`)
          checkFlag = false
          break
        }
        if(!this.fragmentList[i].summary){
          this.$message.error(`${this.fragmentList[i].file.name}无碎片简介`)
          checkFlag = false
          break
        }
      }
      return checkFlag
    },
    async uploadFile(fragment, index) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('fragment/getStsAk', {id: fragment.id}).then(res => {
          let region = res.endpoint;
          let fKey = region.indexOf('//') + 2;
          let lKey = region.indexOf('.');
          let client = new OSS({
            region: region.substring(fKey,lKey),
            accessKeyId: res.accessKeyId,
            accessKeySecret: res.accessKeySecret,
            stsToken: res.securityToken,
            bucket: res.bucketName,
          })
          let tempCheckpoint;
          client.multipartUpload(res.url + fragment.file.name, fragment.file, {
            progress: (p, checkpoint) => {
              // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
              tempCheckpoint = checkpoint;
              this.fragmentList[index].progress = Math.floor(p * 100)
              if(p == 1){
                let endpointPath = res.endpoint.split('/')
                let endpoint = endpointPath[endpointPath.length - 1]
                let url
                if(checkpoint){
                  url = `https://${res.bucketName}.${endpoint}/${checkpoint.name}`;
                }else{
                  url = `https://${res.bucketName}.${endpoint}/${res.url}${fragment.file.name}`
                }
                this.addFragment({uri: res.url + fragment.file.name, url, type: fragment.type, fragment}, {resolve, reject})
              }
            },
          }).catch(err => {
            console.log(err)
          })

        })
      })
    },
    addFragment(data, {resolve, reject}){
      const reqData = {
        id: data.fragment.id,
        mediaUrl: data.uri,
        type: data.type,
      }
      this.$store.dispatch('fragment/addFragmentRes', reqData).then(res=>{
        resolve({url: data.url, title: data.fragment.file.name })
      })
    },
    changeCorrectAnswer(e, optionIndex) {
      console.debug(e.target.checked)
      console.debug(optionIndex)
      if(e.target.checked && (this.subType == 101 || this.subType == 103)){
        this.drill.optionList.map(option => {
          option.correctAnswer = false
        })
        this.drill.optionList[optionIndex].correctAnswer = true
      }
    }
  }
}
</script>

<style scoped lang="less">
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 10px;
}
.dynamic-delete-button:hover {
  color: #777;
}
</style>